export default __webpack_public_path__ + "static/media/logo.dc6fe32d.png";